var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { rbvDropDownContainer: _vm.isOpen } }, [
    _c("div", { staticClass: "rbvDropDownToggler" }, [_vm._t("toggler")], 2),
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass: "rbvDropDown",
            class: _vm.alignClass,
            on: {
              click: function ($event) {
                return _vm.stop($event)
              },
            },
          },
          [_vm._t("dropdown")],
          2
        )
      : _vm._e(),
    _vm.isOpen && _vm.backdrop
      ? _c(
          "div",
          {
            staticClass: "rbvDropDownBackdrop",
            class: _vm.backdropStyle,
            on: { click: _vm.close },
          },
          [_vm._v("   ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }